@if (showResult) {
  <div class="language-assignments">
    <form>
      <div class="flex-row" >
        <label class="label" for="location">Location</label>
        <span id="location">
          <mat-form-field [style.width.px]=204>
            <input matInput type="text" [(ngModel)]="location" [ngModelOptions]="{standalone: true}"
              [disabled]="!canEdit">
          </mat-form-field>
        </span>
      </div>
      <div class="flex-row" >
        <label class="label" for="effectiveDate">Effective Date</label>
        <span id="effectiveDate">
          <emm-effective-date-selection
            source="management"
            [effectiveDate]="newDate"
            (effectiveDateChange)="selectOpenDate($event)"
            [disabled]="!canEdit"
          ></emm-effective-date-selection>
        </span>
      </div>
      <div class="flex-row" >
        <label class="label" for="english">English</label>
        <span id="english">
          <mat-form-field [style.width.px]=204>
            <input matInput type="text" [(ngModel)]="english"
              [ngModelOptions]="{standalone: true}" disabled>
          </mat-form-field>
        </span>
      </div>
      <div class="flex-row" >
        <label class="label" for="spanish">Spanish</label>
        <div id="spanish">
          <mat-select placeholder="{{ spanish }}" [(value)]="this.spanish"
            [style.width.px]=204 [disabled]="!canEdit">
            <mat-option [value]=true>TRUE</mat-option>
            <mat-option [value]=false>FALSE</mat-option>
          </mat-select>
        </div>
      </div>
      <button id="save-button" mat-raised-button (click)="onSubmit()" [disabled]="!canEdit">Save</button>
    </form>
  </div>
}
